module.exports = __webpack_public_path__ + "static/media/CT_2019_30449_9904_pdf.bd2ddf95.pdf";